import React, { useEffect, useRef } from "react";
import { Card, Button } from "react-bootstrap";
import logo from "../../../images/Logo.png";
import CourseCard from "./CourseCard";
import DigitalLearningModules from "./DigitalLearningModules";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
import { toast } from '../common/Toast/toast';

const CourseCompletionCertificate = () => {
  const navigate = useNavigate();
  const hasShownToast = useRef(false);
  const { hasPermission } = useAuth();
  useEffect(() => {
    if (!hasPermission('student-id-card', 'view','lms')) {
      if (!hasShownToast.current) {
        toast.error('You do not have permission to add departments.');
        navigate('/');
        // console.log("hello")
        hasShownToast.current = true;
      }
    }
  }, [hasPermission, navigate]);
  return (
    <div className="d-flex flex-column align-items-center p-3">
      <div className="text-center mb-3">
        <h5 className="mb-1">Course Completion Certificate</h5>
        <p className="text-danger mb-0" style={{ fontSize: "0.875rem" }}>
          *To generate course completion certificate, ensure final score is 75%
          or above.
          <Button variant="link" className="p-0 text-primary">
            view more
          </Button>
        </p>
      </div>
      <Card className="text-dark w-100 shadow hover-effect p-2" style={{ maxWidth: "400px", minHeight: "150px"}}>
      <img 
          src={logo} 
          alt="Logo" 
          className="position-absolute" 
          style={{ top: "10px", right: "10px", width: "40px", height: "35px", opacity: "0.9" }}
        />
        <Card.Body className="d-flex flex-column justify-content-between" style={{ minHeight: "150px" }}>
          <div className="position-relative">
            {/* Background Pattern */}
            <div className="position-absolute bottom-0 start-0 opacity-25"></div>
            <h6 className="text-center mb-4 fs-4">
              Master in Data Software Engineering
            </h6>
          </div>
          <div className="text-center">
            <Button className="w-75 py-2" style={{ pointerEvents: "none" }}>
              Generate Certificate
            </Button>
          </div>
        </Card.Body>
      </Card>
      <CourseCard/>
      <DigitalLearningModules/>
    </div>
  );
};

export default CourseCompletionCertificate;
